/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, pages: NonNullable<unknown> }} Member_Spaces_PageInputs */



/**
* | output |
* | --- |
* | "Page {page} of {pages}" |
*
* @param {Member_Spaces_PageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_spaces_page = /** @type {((inputs: Member_Spaces_PageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Spaces_PageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.pages}`)
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.pages}`)
});